"use client"

import { clearClientCaches } from "@/lib/client-cache"
import { clearLastLogin } from "@/lib/last-login"
import { clearAppQueryClient } from "@/lib/query-client"
import { resetWorkspaceState } from "@/lib/workspace-store"
import { useAuthStore } from "@/stores/auth-store"
import { signOut } from "supertokens-auth-react/recipe/session"

export async function logoutAndClearClientState({
  clearLastLogin: shouldClearLastLogin = false,
}: {
  clearLastLogin?: boolean
} = {}) {
  if (shouldClearLastLogin) {
    clearLastLogin()
  }

  // Mark as guest first so the authenticated layout immediately stops rendering
  // children (returns null). This unmounts ChatWorkspace before the workspace
  // state is cleared, preventing the "Conversation not found" flash.
  useAuthStore.getState().setGuest()

  resetWorkspaceState()
  clearAppQueryClient()
  await clearClientCaches()

  try {
    await signOut()
  } catch {
    // Ignore sign-out failures so the client still returns to a clean guest state.
  }
}
